module.exports = "https://cdn.realtymogul.com/static/media/retire_hero.e5e3f72a.jpg";